module.exports = __webpack_public_path__ + "img/plateImg3.3e56852e.png";